import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { setServerResponse } from "store/application/application-action";
import { useFollowingQuery } from "queries";
import { apiMain } from "services";

import { IUserInfo } from "./types";
import { UserListWidget } from "./UserListWidget";

interface IUserListWidgetAlive {
  title: string;
  link: string;
  items: IUserInfo[];
  className?: string;
  list?: boolean;
  context: string | null;
}

export const UserListWidgetAlive = (props: IUserListWidgetAlive): JSX.Element => {
  const [following, setFollowing] = useState<string[]>([]);
  const [items, setItems] = useState<IUserInfo[]>(props.items);

  const dispatch = useDispatch();
  const query = useFollowingQuery({});

  useEffect(() => {
    if (query.status === "success" && query.data) {
      const ids = query.data.follows.map((user) => user.username);
      setFollowing(ids);
    }
  }, [query.status, query.data]);

  useEffect(() => {
    setItems((prev) => prev.map((n: IUserInfo): IUserInfo => ({
      ...n,
      following: following.indexOf(n.id) >= 0,
    })));
  }, [following]);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  const onFollow = async (id: string, follow: boolean) => {
    const name = props.items.filter((x) => x.id === id)[0].name;

    if (follow) {
      await apiMain.followUser(id, props.context);
      setFollowing(prev => [...prev, id]);
      dispatch(setServerResponse(`Started following ${name}.`));
    } else {
      await apiMain.unfollowUser(id);
      setFollowing(prev => prev.filter(x => x !== id));
      dispatch(setServerResponse(`No longer following ${name}.`));
    }
  };

  return (
    <UserListWidget
      title={props.title}
      link={props.link}
      items={items}
      className={props.className}
      onFollow={onFollow}
      list={props.list}
    />
  );
};
